<template>
  <div class="bg-white px-4 py-6">
    <p-button variant="ghost" class="flex items-center gap-2"
              @click="onDelete">
      <p-icon icon-name="bin"
              size="medium"
              color="blue"/>
      <span>{{ name }} verwijderen</span>
    </p-button>
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  name: string,
  onDelete?: () => void
}>();
</script>
